import httpHandler from '../utilities/HttpHandler';

let isAuthenticated = false;
let profile = null;
let authToken = '';

class AuthHandler {
	setAuthToken = (token, remember) => {
		console.log('remember', remember)
		authToken = 'JWT ' + token;
		console.log('Setting token...');
		if (remember === true) {
			localStorage.setItem('jwt-token', token);
		}
		console.log('Done setting token.');
	};

	getAuthToken = () => {
		console.log('Getting token...');
		let token = localStorage.getItem('jwt-token');
		if (token) {
			authToken = 'JWT ' + token;
		}
		console.log('Done getting token.');
	};

	clearAuthToken = () => {
		authToken = '';
		localStorage.removeItem('jwt-token');
	};

	getProfile = () => {
		console.log('Getting user profile...');
		return httpHandler.get('me').then((result) => {
			if (result.status === 200) {
				if (result.data.profile && result.data.profile.ods_access && result.data.profile.ods_access === true) {
					console.log('Setting user profile...');
					profile = {
						odsAccess: result.data.profile.ods_access,
						odsLocation: result.data.profile.ods_location.toString()
					};
					return true;
				}
				return false;
			} else {
				console.log('Getting user profile failed!!');
			}
		});
	};

	isLoggedIn = () => {
		if (!isAuthenticated) {
			this.getAuthToken();
			return this.getProfile().then((result) => {
				isAuthenticated = result;
				console.log('User Authenticated:', isAuthenticated);
				if (this.stateChanged) {
					console.log('Auth state changed');
					this.stateChanged(profile);
				}
				return isAuthenticated;
			});
		} else {
			return isAuthenticated;
		}
	};

	login = (userData) => {
		console.log('Loging in user...');
		return httpHandler
			.post('api-token-auth', null, userData)
			.then((result) => {
				if (result.status === 200) {
					// Get user profile
					this.setAuthToken(result.data.token, true);
					return this.getProfile().then((result) => {
						console.log('result', result)
						isAuthenticated = result;
						console.log('User Authenticated:', isAuthenticated);
						if (this.stateChanged) {
							console.log('Auth state changed');
							this.stateChanged(profile);
						}
						return isAuthenticated;
					});
				}
				return false;
			})
			.catch((error) => {
				console.log(error.message);
				return 'Something has gone wrong. Please try again.';
			});
	};

	logout = () => {
		console.log('Loging out the user');
		this.clearAuthToken();
		isAuthenticated = false;
		profile = {};
		if (this.stateChanged) {
			console.log('Auth state changed');
			this.stateChanged(this.profile);
		}
		return false;
	};

	reset = (userData) => {
		this.clearAuthToken();
		isAuthenticated = false;
		console.log('Resetting password!');
		return httpHandler
			.put('me/reset_password', null, userData)
			.then((result) => {
				return true;
			})
			.catch((error) => {
				console.log(error.message);
				return error.message;
			});
	};

	onStateChanged = (callback) => {
		console.log('Calling callback');
		this.stateChanged = callback;
	};
}

const authHandler = new AuthHandler();
export { profile, authToken };
export default authHandler;



// WEBPACK FOOTER //
// ./src/utilities/AuthHandler.js